// Legal content — English. Mirror clause-for-clause of fr.js and es.js.
import termsEn from "./termsEn";

export default {
  terms: termsEn,
  privacy: {
    lastUpdatedLabel: "Last updated",
    sections: [
      {
        id: "data-collected",
        heading: "1. Data we collect",
        paragraphs: [
          "We collect account information (name, email), the practice data you enter, and technical data (logs, session cookies) required to operate the service.",
        ],
      },
      {
        id: "use",
        heading: "2. Use",
        paragraphs: [
          "Your data is used to provide and improve the service, process payments, and ensure security. We do not sell your data.",
        ],
      },
      {
        id: "clients-data",
        heading: "3. Your clients' data",
        paragraphs: [
          "You are responsible for processing your own clients' data. Solunary acts as a processor and applies reasonable security measures.",
        ],
      },
      {
        id: "sharing",
        heading: "4. Sharing",
        paragraphs: [
          "We share data only with necessary subprocessors (hosting, payments via Stripe, email via Resend) and where required by law.",
        ],
      },
      {
        id: "retention-rights",
        heading: "5. Retention & rights",
        paragraphs: [
          "You may access, correct, or delete your data from settings or by contacting us. Data is retained as long as needed for the service.",
        ],
      },
      {
        id: "security",
        heading: "6. Security",
        paragraphs: [
          "We apply encryption in transit and access controls. No system is infallible; report any incident.",
        ],
      },
      {
        id: "cookies",
        heading: "7. Cookies",
        paragraphs: [
          "We use essential session cookies for authentication. No third-party advertising cookies.",
        ],
      },
      {
        id: "contact",
        heading: "8. Contact",
        paragraphs: [
          "Questions: hey@solunary.health.",
        ],
      },
    ],
  },
};
